import { debounce } from './debounce'

const burger = document.querySelector('[data-menu-burger]')
const burgerWrap = document.querySelector('[data-menu-burger-wrapper]')
const backdrop = document.querySelector('[data-burger-backdrop]:not(.header__navlist-wrap)')
const content = document.querySelector('[data-burger-content]')
const bodyElem = document.querySelector('body')

const headerEl = document.querySelector('#header')

burger.addEventListener('click', () => {
  if (burger.classList.contains('opened')) {
    content.scrollTo(0, 0)
    closeMenu()
  } else {
    openMenu()
  }
})

document.addEventListener('click', event => {
  if (event.target.attributes['data-burger-backdrop']) {
    closeMenu()
  }
})

window.addEventListener('keyup', event => {
  if (event.key === 'Escape') {
    closeMenu()
  }
})

function closeMenu() {
  burger.classList.remove('opened')
  backdrop.classList.remove('opened')
  burgerWrap.classList.remove('opened')
  bodyElem.classList.remove('scroll-forbidden')

  headerEl.classList.add('with_background')

  const bwcWidget = document.getElementById('bwc-widget-action')
  if (bwcWidget) {
    bwcWidget.style.display = 'flex'
  }
}

function openMenu() {
  burgerWrap.classList.add('opened')
  burger.classList.add('opened')
  backdrop.classList.add('opened')
  bodyElem.classList.add('scroll-forbidden')

  headerEl.classList.remove('with_background')

  const bwcWidget = document.getElementById('bwc-widget-action')
  if (bwcWidget) {
    bwcWidget.style.display = 'none'
  }
}

function updateHiddenBlockHeight(element) {
  const hiddenBlock = element.nextElementSibling

  if (element.classList.contains('opened')) {
    hiddenBlock.style.height = `${hiddenBlock.scrollHeight}px`
  } else {
    hiddenBlock.style.height = '0'
  }
}

headerEl.addEventListener('click', e => {
  const el = e.target.closest('[data-burger-item]')
  if (!el) return

  if (window.innerWidth >= 1130) return

  const currentItemElem = document.querySelector('.opened[data-burger-item]')
  if (currentItemElem && currentItemElem !== el) {
    currentItemElem.classList.remove('opened')
    currentItemElem.nextElementSibling.style.height = '0'
  }

  el.classList.toggle('opened')
  updateHiddenBlockHeight(el)
})

const handleResize = debounce(() => {
  const burgerItems = document.querySelectorAll('[data-burger-item]')

  burgerItems.forEach(el => {
    const hiddenBlock = el.nextElementSibling
    if (window.innerWidth >= 1130) {
      el.classList.remove('opened')

      if (hiddenBlock) {
        hiddenBlock.style.height = 'auto'
      }
    } else {
      updateHiddenBlockHeight(el)
    }
  })
}, 300)

window.addEventListener('resize', handleResize)

function manageHeaderBg() {
  if (window.scrollY > 0) {
    headerEl.classList.add('with_background')
  } else {
    headerEl.classList.remove('with_background')
  }
}

manageHeaderBg()

window.addEventListener('scroll', function () {
  manageHeaderBg()
})
